import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobusGrey = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 9.4C2.30767 5.26196 5.77184 2 10 2C9.33347 2 8.74001 2.29137 8.2518 2.7369C7.76604 3.1802 7.35554 3.79902 7.02352 4.53052C6.68954 5.26634 6.43011 6.12695 6.25453 7.06089C6.11377 7.80955 6.02811 8.59881 5.99956 9.4H2ZM2 10.6H5.99956C6.02811 11.4012 6.11377 12.1904 6.25453 12.9391C6.43011 13.8731 6.68954 14.7337 7.02352 15.4695C7.35554 16.201 7.76604 16.8198 8.2518 17.2631C8.74001 17.7086 9.33347 18 10 18C5.77184 18 2.30767 14.738 2 10.6Z",
			fill: "#616161"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 3.11628C9.77938 3.11628 9.49438 3.20989 9.16296 3.51233C8.82911 3.81701 8.49488 4.29452 8.19959 4.9451C7.90625 5.59136 7.66807 6.37152 7.50416 7.24335C7.37507 7.92994 7.295 8.65775 7.26689 9.4H12.7331C12.705 8.65775 12.6249 7.92994 12.4958 7.24336C12.3319 6.37153 12.0938 5.59137 11.8004 4.9451C11.5051 4.29452 11.1709 3.81701 10.837 3.51233C10.5056 3.20989 10.2206 3.11628 10 3.11628Z",
			fill: "#616161"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.50416 12.7566C7.66807 13.6285 7.90625 14.4086 8.19959 15.0549C8.49488 15.7055 8.8291 16.183 9.16296 16.4877C9.49438 16.7901 9.77938 16.8837 10 16.8837C10.2206 16.8837 10.5056 16.7901 10.837 16.4877C11.1709 16.183 11.5051 15.7055 11.8004 15.0549C12.0937 14.4086 12.3319 13.6285 12.4958 12.7566C12.6249 12.0701 12.705 11.3423 12.7331 10.6H7.26689C7.295 11.3423 7.37507 12.0701 7.50416 12.7566Z",
			fill: "#616161"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 2C10.6665 2 11.26 2.29137 11.7482 2.7369C12.234 3.1802 12.6445 3.79902 12.9765 4.53052C13.3105 5.26634 13.5699 6.12695 13.7455 7.06089C13.8862 7.80955 13.9719 8.59881 14.0004 9.4H18C17.6923 5.26196 14.2282 2 10 2Z",
			fill: "#616161"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7455 12.9391C13.5699 13.8731 13.3105 14.7337 12.9765 15.4695C12.6445 16.201 12.234 16.8198 11.7482 17.2631C11.26 17.7086 10.6665 18 10 18C14.2282 18 17.6923 14.738 18 10.6H14.0004C13.9719 11.4012 13.8862 12.1904 13.7455 12.9391Z",
			fill: "#616161"
		})
	]
});
const ForwardRef = forwardRef(SvgGlobusGrey);
export default ForwardRef;
